import { createAsyncThunk } from '@reduxjs/toolkit';
import { capitalize } from '@/libs/helpers';
import { validateName } from '@/libs/validation/validateName';
import { formsActions } from './index';
export const setInsurerName = createAsyncThunk('', async ({ field, value }, thunkApi) => {
    const transformedValue = capitalize(value);
    const { error } = validateName(transformedValue);
    thunkApi.dispatch(formsActions._setInsurerField({ field, value: transformedValue }));
    thunkApi.dispatch(formsActions._setInsurerFieldError({ field, error }));
});
